import appAxios from '..'
import { GET_ORDER } from '../constants'
import { ApiResultGeneric, GetOrderData } from './types'

const getOrder = async (
  orderId: string
): Promise<ApiResultGeneric<GetOrderData> | null> => {
  try {
    const params = { orderId: orderId }
    const result = await appAxios.get<ApiResultGeneric<GetOrderData>>(
      GET_ORDER,
      { params }
    )

    return result.data
  } catch (err: any) {
    if (err.response) return err.response.data
    return null
  }
}

const orderApi = {
  getOrder,
}

export default orderApi
